import { render, staticRenderFns } from "./AreYouSure.vue?vue&type=template&id=b391fd40&scoped=true&"
import script from "./AreYouSure.vue?vue&type=script&lang=js&"
export * from "./AreYouSure.vue?vue&type=script&lang=js&"
import style0 from "./AreYouSure.vue?vue&type=style&index=0&id=b391fd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b391fd40",
  null
  
)

export default component.exports